import { logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";
import { PROXY_APPROVED, PROXY_DECLINED, PROXY_DELETE, PROXY_CANCELLED, PROXY_PENDING, A1cScreeningOptions } from "../constants/textConstants";

const proxyApiUrl = typeof window !== 'undefined' ? window.serverData.data.proxyApiUrl : ''; // window is undefined during pre-render
const apiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : '';
const BASE_URL = window.serverData.data.portalAPIURL;
const UseTermsV2Endpoint = window.serverData.data.useTermsV2Endpoint;
const myBswHealthBffBaseUrl = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbff : '';
const functionsKey = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbfffunctionskey : '';

const engagementBffApiBaseUrl = !!window ? window.serverData.data.engagementBffApiBaseUrl : '';
const engagementBffFunctionsKey = !!window ? window.serverData.data.engagementBffFunctionsKey : '';

//Keeping Pharamcy proxy activity codes which we have already.
export const getProxiesInfo = (token, userId, proxySource) => {
    const url = tools.buildUrl(proxyApiUrl, 'Api/Proxy/ProxyInfo?userId=' + encodeURIComponent(userId) + '&proxySource=' + encodeURIComponent(proxySource));
    const start = new Date();
    let activityCode = "MBHWeb.Api.Rx.Proxy.GetProxyInfo";
    if (proxySource === "Rx,Epic") {
        activityCode = "MBHWeb.Api.RxAndEpic.Proxy.GetProxyInfo";
    }
    let params = {
        headers: {
            Authorization: `bearer ${token}`
        },
        method: "GET"
    };
    return fetch(url, params).then(response => {
        //debugger;
        logAPI(activityCode, start, url);
        return response.json();
    }).catch((err) => {
        //debugger;
        console.error(err);
        logAPI(`${activityCode}.Failure`, start, url, err);
        return { WhoCanManageYou: [], WhoYouCanManage: [] };
    });
};

//Handle ExternalLoginId vs patientid depends on proxyInfo.
export const getAccessList = (token, userId, proxySource) => {
    return getProxiesInfo(token, userId, proxySource).then(response => {
        const list = response && response.WhoYouCanManage && response.WhoYouCanManage
            .filter(userAccess => userAccess.Status && userAccess.Status.toLowerCase() === 'approved')
            .map((userAccess, index) => {
                return {
                    firstName: userAccess.FirstName,
                    lastName: userAccess.LastName,
                    displayName: userAccess.FirstName + ' ' + userAccess.LastName,
                    pharmacyPatientId: userAccess.ExternalLoginId ? userAccess.ExternalLoginId : userAccess.PatientId ? userAccess.PatientId : null,
                    proxySource: userAccess.ProxySource,
                    index: JSON.stringify(index + 1)
                };
            });
        return list;
    });
};

//To fetch all family members of loggedIn User
export const getFamilyMembersList = (token, userId, proxySource) => {
    return getProxiesInfo(token, userId, proxySource).then(response => {
        const list = response && response.WhoYouCanManage && response.WhoYouCanManage
            .filter(userAccess => userAccess.Status && (userAccess.Status.toLowerCase() === 'approved' || userAccess.Status.toLowerCase() === 'pending'))
            .map((userAccess, index) => {
                return {
                    firstName: userAccess.FirstName,
                    lastName: userAccess.LastName,
                    displayName: userAccess.FirstName + ' ' + userAccess.LastName,
                    pharmacyPatientId: userAccess.ExternalLoginId ? userAccess.ExternalLoginId : userAccess.PatientId ? userAccess.PatientId : null,
                    proxySource: userAccess.ProxySource,
                    status:userAccess.Status,
                    index: JSON.stringify(index + 1)
                };
            });
        return list;
    });
};

//Keeping Pharamcy proxy activity codes which we have already.
export const initiateProxy = (token, attachments, proxySource, receiver, requester, requestType) => {
    const url = encodeURI(`${proxyApiUrl}api/Proxy/InitiateProxy`);
    const start = new Date();
    const REQUEST = "request";
    const REQUESTV2 = "request.v2";
    const GRANT = "grant";
    const source = proxySource === 'rx' ? "Rx" : proxySource === 'rx,epic' ? "RxAndEpic" : "Epic";
    const data = { attachments, proxySource, receiver, requester, requestType };
    let activityCode = '';
    if (proxySource && proxySource.toLowerCase() === 'rx') {
        activityCode = "MBHWeb.Api.Rx.Proxy.RequestProxyAccess";
    } else {
        activityCode = `MBHWeb.Api.Proxy.${source}.${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}`;
    }
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    return fetch(url, params).then(response => {
        //if (response && response.status && response.status === 200) {
        //    logAPI(activityCode, start, url);
        //    return response.json();
        //} else {
        //    return Promise.reject(response);
        //}
        if (response && response.status >= 200 && response.status < 300) {
            logAPI(activityCode, start, url);
            return response.json();
        } else if (response && response.status >= 400 && response.status < 500) {
            logAPI(`${activityCode}.Failure`, start, url);
            return response.text().then(error => { throw JSON.parse(error); });
        }
        else {
            return Promise.reject(response.statusText);
        }
    }).catch(err => { logAPI(`${activityCode}.Failure`, start, url, err); return Promise.reject(err); });
};

export const getProxyRelationship = (token) => {
    const fullUrl = `${proxyApiUrl}api/Proxy/ProxyRelationship`;
    let params = {
        headers: {
            Authorization: `bearer ${token}`
        },
        method: "GET"
    };

    var start = new Date();
    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Proxy.GetProxyRelationshipTypes", start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Proxy.GetProxyRelationshipTypes.Failure", start, fullUrl, error);
            return Promise.reject(error);
        });
};

export const verifyRequestorDateOfBirth = (token, proxyRequestId, dateOfBirth) => {
    const url = encodeURI(`${proxyApiUrl}api/Proxy/VerifyRequesterDOB?proxyRequestId=${proxyRequestId}&dateOfBirth=${dateOfBirth}`);
    const start = new Date();
    let data = { proxyRequestId, dateOfBirth };
    const params = {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    let activityCode = `MBHWeb.Api.Epic.Proxy.VerifyRequestorDOB`;
    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            logAPI(activityCode, start, url);
            return Promise.resolve(response.json());
        } else if (response.status === 400) {
            logAPI(`${activityCode}.Failure`, start, url);
            return response.text().then(error => { throw JSON.parse(error); });
        }
        else {
            return Promise.reject(response.statusText);
        }
    }).catch(err => {
        logAPI(`${activityCode}.Failure`, start, url, err);
        return Promise.reject(err);
    });
};

export const getProxyTermsAndConditions = (token, featureId) => {
    if (!UseTermsV2Endpoint) {
        if (featureId !== null) {
            const url = `${BASE_URL}/TCC/FetchCurrent`;
        const params = {
            method: "POST",
            body: JSON.stringify({ featureid: featureId }),
            headers: {
                "Authorization": 'bearer ' + token,
                "Accept": "application/json",
                "Content-type": "application/json"
            },
        };
            var start = new Date();
            return fetch(url, params).then(response => {
                if (response.status >= 200 && response.status < 300) {
                    logAPI("MBHWeb.Api.GetTermsConditions.ByFeatureId.Success", start, url);
                    return Promise.resolve(response.json());
                } else {
                    logAPI("MBHWeb.Api.GetTermsConditions.ByFeatureId.Failure", start, url);
                    return Promise.reject(response);
                }
            }).catch((e) => {
                logAPI("MBHWeb.Api.GetTermsConditions.ByFeatureId.Failure", start, url, e);
                return Promise.reject(err);
            });
        }
    }
    else {
        if (featureId !== null) {
            const url = `${apiBaseUrl}v2/HealthSource/TermsAndConditions/feature/${featureId}`;
            let params = {
                headers: {
                    Authorization: `bearer ${token}`
                },
                method: "GET"
            };
            var start = new Date();
            return fetch(url, params).then(response => {
                if (response.status >= 200 && response.status < 300) {
                    logAPI("MBHWeb.Api.GetTermsConditions.ByFeatureId.Success", start, url);
                    return Promise.resolve(response.json());
                } else {
                    logAPI("MBHWeb.Api.GetTermsConditions.ByFeatureId.Failure", start, url);
                    return Promise.reject(response);
                }
            }).catch((e) => {
                logAPI("MBHWeb.Api.GetTermsConditions.ByFeatureId.Failure", start, url, e);
                return Promise.reject(err);
            });

        }


    }
};

export const acceptProxyTermsAndConditions = (token, featureId, isAccepted, userName, email, loginId, proxyId, versionId) => {
    if (!UseTermsV2Endpoint) {
        if (featureId !== null) {
            const url = `${BASE_URL}/TCC/AcceptCurrent`;
            const params = {
                method: "POST",
                body: JSON.stringify({ VersionId: versionId, Featureid: featureId, IsAccepted: isAccepted, UserName: userName, Email: email, LoginId: loginId, ProxyId: proxyId }),
                headers: {
                    "Authorization": 'bearer ' + token,
                    "Accept": "application/json",
                    "Content-type": "application/json"
                },
            };
            var start = new Date();
            return fetch(url, params).then(response => {
                if (response.status >= 200 && response.status < 300) {
                    logAPI("MBHWeb.Api.AcceptTermsConditions.ById.Get.Success", start, url);
                    return Promise.resolve(response.json());
                } else {
                    logAPI("MBHWeb.Api.AcceptTermsConditions.ByFeatureId.Failure", start, url);
                    return Promise.reject(response);
                }
            }).catch((e) => {
                logAPI("MBHWeb.Api.AcceptTermsConditions.ByFeatureId.Failure", start, url, e);
                return Promise.reject(err);
            });
        }
    } else {
        if (featureId !== null) {
            const url = `${apiBaseUrl}v2/HealthSource/TermsAndConditions/feature/${featureId}`;
            const params = {
                method: "PUT",
                body: JSON.stringify([{ VersionId: versionId, Featureid: featureId, IsAccepted: isAccepted, UserName: userName, Email: email, LoginId: loginId, ProxyId: proxyId }]),
                headers: {
                    "Authorization": 'bearer ' + token,
                    "Accept": "application/json",
                    "Content-type": "application/json"
                },
            };
            var start = new Date();
            return fetch(url, params).then(response => {
                if (response.status >= 200 && response.status < 300) {
                    logAPI("MBHWeb.Api.AcceptTermsConditions.ById.Get.Success", start, url);
                    return Promise.resolve(response.json());
                } else {
                    logAPI("MBHWeb.Api.AcceptTermsConditions.ByFeatureId.Failure", start, url);
                    return Promise.reject(response);
                }
            }).catch((e) => {
                logAPI("MBHWeb.Api.AcceptTermsConditions.ByFeatureId.Failure", start, url, e);
                return Promise.reject(err);
            });
        }
    }

};

//Keeping Pharmacy proxy activity codes which we have already. PROXY_PENDING only apply if user is doing anonymous request by email.
export const changeRequestStatus = (token, proxyRequestId, proxySource, requestType, status, reason, dateOfBirth = '', isUnknown = false) => {
    const url = encodeURI(`${proxyApiUrl}api/Proxy/ChangeRequestStatus`);
    const start = new Date();
    const REQUEST = "request";
    const REQUESTV2 = "request.v2";
    const GRANT = "grant";
    const source = proxySource === 'rx' ? "Rx" : proxySource === 'rx,epic' ? "RxAndEpic" : "Epic";
    let data = { proxyRequestId, proxySource, requestType, status, reason };
    if (dateOfBirth) {
        data["dateOfBirth"] = dateOfBirth;
    }
    if (isUnknown) {
        data["isUnknown"] = isUnknown;
    }
    let activityCode = '';
    if (status === PROXY_APPROVED)
        activityCode = `MBHWeb.Api.${source}.Proxy.ApproveProxy${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}`;
    else if (status === PROXY_DECLINED)
        activityCode = `MBHWeb.Api.${source}.Proxy.DeclineProxy${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}`;
    else if (status === PROXY_DELETE || status === PROXY_CANCELLED)
        activityCode = `MBHWeb.Api.${source}.Proxy.CancelProxy${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}`;
    else if (status === PROXY_PENDING)
        activityCode = `MBHWeb.Api.${source}.Proxy.LinkProxy${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}`;

    const params = {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    return fetch(url, params).then(response => {
        if (response && response.status >= 200 && response.status < 300) {
            logAPI(activityCode, start, url);
            return Promise.resolve(response.json());
        } else {
            if (response && ((response.status === 400 && response.statusText === "Bad Request")
                || (response.status === 401 && response.statusText === "Unauthorized")
                || (response.status === 409 && response.statusText === "Conflict"))) {
                logAPI(`${activityCode}.Failure`, start, url);
                return response.text().then(error => { throw JSON.parse(error); });
            } else {
                return Promise.reject(response.statusText);
            }
        }
    }).catch(err => {
        logAPI(`${activityCode}.Failure`, start, url, err);
        console.log(err);
        //if (status !== 'P') {
        return Promise.reject(err);
        //}
    });
};

export const declineProxyInLogoutMode = (token, proxyRequestId, proxySource, requestType, status, reason, dateOfBirth = '', isUnknown = false) => {
    const url = `${BASE_URL}/api/proxy/DeclineProxy`;
    const start = new Date();
    const REQUEST = "request";
    const REQUESTV2 = "request.v2";
    const GRANT = "grant";
    const source = proxySource === 'rx' ? "Rx" : proxySource === 'rx,epic' ? "RxAndEpic" : "Epic";
    let data = { ProxyRequestId: proxyRequestId, ProxySource: proxySource, RequestType: requestType, Status: status, Reason: reason };
    if (isUnknown) {
        data["IsUnknown"] = isUnknown;
    }
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        if (response && response.fetchSuccessful) {
            logAPI(`MBHWeb.Api.${source}.Proxy.DeclineProxy${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}`, start, url, { isLogoutMode: true });
            return response;
        }
        else {
            return Promise.reject(response.statusCode);
        }
    }).catch(err => {
        logAPI(`MBHWeb.Api.${source}.Proxy.DeclineProxy${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}.Failure`, start, url, { error: err, isLogoutMode: true }); return Promise.reject(err);
    });
};

//Keeping Pharamcy proxy activity codes which we have already.
export const resendProxyAccess = (token, proxyRequestId, proxySource, requestType) => {
    const url = encodeURI(`${proxyApiUrl}Api/Proxy/ResendProxyAccess?proxyRequestId=${proxyRequestId}&proxySource=${proxySource}`);
    const start = new Date();
    const REQUEST = "request";
    const REQUESTV2 = "request.v2";
    const GRANT = "grant";
    const source = proxySource === 'rx' ? "Rx" : proxySource === 'rx,epic' ? "RxAndEpic" : "Epic";
    let params = {
        headers: {
            Authorization: `bearer ${token}`
        },
        method: "PUT"
    };

    return fetch(url, params)
        .then(response => {
            logAPI(`MBHWeb.Api.${source}.Proxy.ResendProxyAccess${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}`, start, url);
            return response.json();
        })
        .catch(error => {
            logAPI(`MBHWeb.Api.${source}.Proxy.ResendProxyAccess${requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "")}.Failure`, start, url, error);
            return Promise.reject(error);
        });
};

export const getEpicWhoCanManageYou = (token, userName) => {
    const url = `${apiBaseUrl}v2/Epic/WhoCanManageYou?userName=${encodeURIComponent(userName)}`;
    const start = new Date();

    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Proxy.GetEpicWhoCanManageYou", start, url);
        return response;
    }).catch((err) => {
        logAPI("MBHWeb.Api.Proxy.GetEpicWhoCanManageYou.Failure", start, url, err);
        return { Proxies: [] };
    });
};

export const proxyStatusInLogoutMode = (token, proxyRequestId) => {
    const url = `${BASE_URL}/api/proxy/ProxyStatus?proxyRequestId=${encodeURIComponent(proxyRequestId)}`;
    const start = new Date();
    let activityCode = "MBHWeb.Api.Proxy.ProxyStatus";

    return fetch2(url, token, null, 'GET').then(response => {
        //debugger;
        logAPI(activityCode, start, url);
        return response;
    }).catch((err) => {
        //debugger;
        console.error(err);
        logAPI(`${activityCode}.Failure`, start, url, err);
        return null;
    });
};

export const proxyDetails = (token, proxyRequestId) => {
    const fullUrl = encodeURI(`${proxyApiUrl}Api/Proxy/ProxyDetails?proxyRequestId=${proxyRequestId}`);
    let activityCode = "MBHWeb.Api.Proxy.ProxyDetails";
    let params = {
        headers: {
            Authorization: `bearer ${token}`
        },
        method: "GET"
    };

    var start = new Date();
    return fetch(fullUrl, params)
        .then(response => {
            logAPI(activityCode, start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI(`${activityCode}.Failure`, start, fullUrl, error);
            return Promise.reject(error);
        });
};

//Fetching ProxySuggestions data from loggedIn User.
export const getProxySuggestion = (token) => {
    let activityCode = "MBHWeb.Api.Proxy.ProxySuggestions";    
    const url = tools.buildUrl(myBswHealthBffBaseUrl, '/v1/proxysuggestions');
    const start = new Date();
    let params = {
        headers: {
            "authorization": "bearer " + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache",
            "x-functions-key": functionsKey,
        },
        method: "GET"
    };
    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            logAPI(`${activityCode}.Success`, start, url);
            return Promise.resolve(response.json());
        } else {
            logAPI(`${activityCode}.Failure`, start, url);
            return Promise.reject(response);
        }
        return response.json();
    }).catch((err) => {
        logAPI(`${activityCode}.Failure`, start, url, err);
        console.error(err);
        return Promise.reject(err);
    });
};

//To post the data in mammography-flow
export const submitCareGapInfo = (token, mammographyFlowFormInputs, mammographyNoReason, mammographyOption, careGapAttachments) => {
    const url = encodeURI(`${myBswHealthBffBaseUrl}v1/caregap/inbasket/send`);
    const start = new Date();
    let today = new Date().toLocaleDateString()
    let mammographyOptions = ['I don’t need a mammogram', 'I don’t need an A1C screening']

    let Procedure = mammographyFlowFormInputs?.procedureType || mammographyNoReason?.procedureType
        ? mammographyNoReason?.procedureType || mammographyFlowFormInputs?.procedureType
            : "Mammography" 
    let DateCompleted = `${mammographyFlowFormInputs?.pMonth}/01/${mammographyFlowFormInputs?.pYear}`; //today;
    let FacilityName = mammographyFlowFormInputs?.name;
    let FacilityAddress = mammographyFlowFormInputs?.FacilityAddress || '';
    let FacilityPhone = mammographyFlowFormInputs?.pNumber;
    let FacilityFax = '';
    let procedureNotNeeded = mammographyOptions.some((option) => mammographyOption === option)
    let notNeededReason = procedureNotNeeded === true ? `${mammographyNoReason?.selectedReason}${mammographyNoReason?.selectedReason==="Other"? `.${mammographyNoReason?.description}` : ''}` : "";
    let EpicAttachments = careGapAttachments

    if (procedureNotNeeded) {
        FacilityName = mammographyNoReason?.data?.facilityName;
        FacilityPhone = mammographyNoReason?.data?.phoneNumber;
        DateCompleted = mammographyNoReason?.data?.procedureMonth || mammographyNoReason?.data?.procedureYear ? `${mammographyNoReason?.data?.procedureMonth}/01/${mammographyNoReason?.data?.procedureYear}` : "";
    }
     
    const data = { Procedure, DateCompleted, FacilityName, FacilityAddress, FacilityPhone, FacilityFax, procedureNotNeeded, notNeededReason, ...(careGapAttachments != null && { EpicAttachments }) };
    let activityCode = 'MBHWeb.Api.Proxy.MammographyFlow';
    const payload = mammographyFlowFormInputs ? { mammographyOption, ...mammographyFlowFormInputs, careGapAttachments } : { mammographyOption, ...mammographyNoReason };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": functionsKey
        }
    };
    let result = { data: null, success: false, errorMsg: null };
    return fetch(url, params).then(response => {
        if (response && response.status >= 200 && response.status < 300) {
            logAPI(activityCode, start, url, { payload : payload});
            result.success = true;
            return result;
        } else {
            result.success = false;
            logAPI(`${activityCode}.Fail`, start, url, { payload: payload });
            result.errorMsg = response.statusText;
            return result
        }
    }).catch(err => {
        result.errorMsg = err;
        result.success = false;
        logAPI(`${activityCode}.Failure`, start, url, { payload: payload, err });
        //return result;
        return Promise.reject(result);
    });
};

export const submitCareGapData = (token, careGapFlowFormInputs, careGapNoReason, careGapSelectedOption, careGapProcedureType, careGapAttachments, careGapsSessionId) => {
    const url = encodeURI(`${myBswHealthBffBaseUrl}v1/caregap/inbasket/send`);
    const start = new Date();
    let today = new Date().toLocaleDateString()
    let careGapOptions = ['I don’t need a mammogram', A1cScreeningOptions.DontNeed, 'I don’t need an annual wellness visit', "I don’t need a colorectal cancer screening"]

    let Procedure = careGapProcedureType;
    let DateCompleted = careGapFlowFormInputs?.dateCompleted ? careGapFlowFormInputs?.dateCompleted : `${careGapFlowFormInputs?.pMonth}/01/${careGapFlowFormInputs?.pYear}`; //today;
    let FacilityName = careGapFlowFormInputs?.name;
    let FacilityAddress = careGapFlowFormInputs?.FacilityAddress || '';
    let FacilityPhone = careGapFlowFormInputs?.pNumber;
    let FacilityFax = '';
    let FacilityScreenMethod= careGapFlowFormInputs?.sMethod;
    let ProcedureNotNeeded = careGapOptions.some((option) => careGapSelectedOption === option)
    let NotNeededReason = ProcedureNotNeeded === true ? `${careGapNoReason?.selectedReason}${careGapNoReason?.selectedReason === "Other" ? `.${careGapNoReason?.description}` : ''}` : "";
    let EpicAttachments = careGapAttachments;
    let AdditionalDetails = [{ key: careGapProcedureType, value: careGapFlowFormInputs ? careGapFlowFormInputs?.reading : "", careGapsSessionId: careGapsSessionId }]

    if (ProcedureNotNeeded) {
        FacilityName = careGapNoReason?.data?.facilityName;
        FacilityPhone = careGapNoReason?.data?.phoneNumber;
        DateCompleted = careGapNoReason?.data?.procedureMonth || careGapNoReason?.data?.procedureYear ? `${careGapNoReason?.data?.procedureMonth}/01/${careGapNoReason?.data?.procedureYear}` : "";
    }

    const data = { Procedure, DateCompleted, FacilityName, FacilityAddress, FacilityPhone, FacilityFax, FacilityScreenMethod, ProcedureNotNeeded, NotNeededReason, ...(careGapAttachments != null && { EpicAttachments }), AdditionalDetails };
    let activityCode = `MBHWeb.Api.Proxy.${careGapProcedureType}Flow`;
    const payload = careGapFlowFormInputs ? { careGapSelectedOption, ...careGapFlowFormInputs, careGapAttachments } : { careGapSelectedOption, ...careGapNoReason };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": functionsKey
        }
    };
    let result = { data: null, success: false, errorMsg: null };
    return fetch(url, params).then(response => {
        if (response && response.status >= 200 && response.status < 300) {
            logAPI(activityCode, start, url, { payload: payload });
            result.success = true;
            return result;
        } else {
            result.success = false;
            logAPI(`${activityCode}.Fail`, start, url, { payload: payload });
            result.errorMsg = response.statusText;
            return result
        }
    }).catch(err => {
        result.errorMsg = err;
        result.success = false;
        logAPI(`${activityCode}.Failure`, start, url, { payload: payload, err });
        //return result;
        return Promise.reject(result);
    });
};
export const submitCareGapSetupData = (token, careGapFlowFormInputs, careGapSelectedOption, careGapProcedureType, careGapsSessionId, currentUserInfo) => {
    const url = encodeURI(`${engagementBffApiBaseUrl}/v2/caregap/inbasket/send`);
    //const url = encodeURI('https://fnengagementbff-tst2-eastus2.azurewebsites.net/api/v2/careGap/inBasket/send');
    const start = new Date();
    let today = new Date().toLocaleDateString()
    let careGapOptions = ['I don’t need a mammogram', A1cScreeningOptions.DontNeed, 'I don’t need an annual wellness visit', "I don’t need a colorectal cancer screening"]
    let procedure = "Colorectal Exam" ;
    let facilityPhone = careGapFlowFormInputs?.pNumber;
    let patientId = currentUserInfo;
    let patientIdType = "External";
    let subjectCode = "requestcalltoschedule";
    let messageData = [{ key: "phone", value: careGapFlowFormInputs ? careGapFlowFormInputs?.pNumber : "" }, {key: "careGapsSessionId", value: careGapsSessionId }]

    

    const data = { procedure, patientId, patientIdType, subjectCode, messageData };
    let activityCode = `MBHWeb.Api.Proxy.${careGapProcedureType}Flow`;
    const payload = careGapFlowFormInputs ? { careGapSelectedOption, ...careGapFlowFormInputs } : { careGapSelectedOption, ...careGapNoReason };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": engagementBffFunctionsKey //"sZIjopxciFOpSJHb5utBy-l6WMiciCHTHxK9P_tTauIcAzFuK_9q5w=="
        }
    };
    let result = { data: null, success: false, errorMsg: null };
    return fetch(url, params).then(response => {
        if (response && response.status >= 200 && response.status < 300) {
            logAPI(activityCode, start, url, { payload: payload });
            result.success = true;
            return result;
        } else {
            result.success = false;
            logAPI(`${activityCode}.Fail`, start, url, { payload: payload });
            result.errorMsg = response.statusText;
            return result
        }
    }).catch(err => {
        result.errorMsg = err;
        result.success = false;
        logAPI(`${activityCode}.Failure`, start, url, { payload: payload, err });
        //return result;
        return Promise.reject(result);
    });
};